import { Component, OnInit, Inject, Input, HostListener  } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ProjectInfo } from '../model/project.model';
import { ProjectDocumentInfo } from '../model/projectdocument.model';
import { Observable } from 'rxjs';
import { buffer, map, startWith } from 'rxjs/operators';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-meeting',
  templateUrl: './meeting.component.html',
  styleUrls: ['./meeting.component.css']
})
export class MeetingComponent implements OnInit {

  /******************************* Variables ********************************/
  @Input() ProjectId: string;
  
  baseurl: string;
  baselineFilesToUpload: File[];
  baselinePathFile: string = '';
  ProjectPromise: Promise<ProjectInfo[]>
  ProjectDocumentPromise: Promise<ProjectDocumentInfo[]>
  ProjectDocumentList: ProjectDocumentInfo[]
  ProjectsFileName: string[]
  filteredOptions: Observable<string[]>;
  isSubmitted: any;
  Filename: string;
  isUploadSubmitted: boolean = false;
  ValidateFilename: boolean = false;
  CurrentTabSelected: string;
  UserRole: string;
  IsShowForThisUser: boolean;
  IsShowVersion: boolean;
  IsClearList: boolean = false;

  //Controls variable
  txtFileName = new FormControl();
  txtFileNameCreate = new FormControl();
  txtFileVersion = new FormControl();
  hidProjectId: number
  modelFilenameCreate: string;
 
  //Pagination variable
  public currentPageNumber: number
  public ProjectTotal: number
  public totalPages: number
  public environment: number

  /******************************* Variables ********************************/


  /******************************* Functions ********************************/
  //Constructor
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  //Initial data
  async ngOnInit() {
    this.currentPageNumber = 1;
    this.environment = environment.PageSizeSmall;
    this.UserRole = localStorage.getItem("EmpRoleCode");
    this.IsShowForThisUser = (this.UserRole != "CUSTOMER");
    this.IsShowVersion = false;
    this.CurrentTabSelected = 'All Document';
    await this.LoadGroupProjectDocument();
    await this.OnLoadCountDocumentList();
    
    
  }

  SetInitialAutoComplete() {
    this.filteredOptions = this.txtFileName.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );
  }

  LoadProjectDocumentList(auth_token): Observable<ProjectDocumentInfo[]> {
    
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeSmall;

      var objectjson = {};
      objectjson['ProjectDocumentProjectID'] = Number(this.ProjectId);
      objectjson['ProjectDocumentFileName'] = $('#txtSchFileName').val();
      objectjson['FlagDelete'] = "N";
      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectDocumentInfo[]>(this.baseurl + "ProjectDocument/GetGroupProjectDocument",
          strjson, httpOptions);
    
  }

  async LoadGroupProjectDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectDocumentList(auth_token)
        .subscribe({
          next: data => {
            this.ProjectDocumentList = data;

            var tmpArr = [];
            $.each(data, function () {

              tmpArr.push(!!this.ProjectDocumentFileName ? this.ProjectDocumentFileName : ' ');
            });
            this.ProjectsFileName = tmpArr;
            this.SetInitialAutoComplete();
          },
          error: error => {

            console.error('There was an error!', error);
          }
        });
    }
  }

  async LoadHistoryProjectDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeSmall;

      var objectjson = {};
      objectjson['ProjectDocumentProjectID'] = Number(this.ProjectId);
      objectjson['ProjectDocumentFileName'] = $('#txtSchFileName').val();
      objectjson['FlagDelete'] = "N";
      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;



      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<ProjectDocumentInfo[]>(this.baseurl + "ProjectDocument/GetProjectDocument",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            this.ProjectDocumentList = data;

            var tmpArr = [];
            $.each(data, function () {
              if (!!this.ProjectDocumentFileName && tmpArr.indexOf(this.ProjectDocumentFileName)) {
                tmpArr.push(!!this.ProjectDocumentFileName ? this.ProjectDocumentFileName : ' ');
              }
            });
            this.ProjectsFileName = tmpArr;
            this.SetInitialAutoComplete();
          },
          error: error => {

            console.error('There was an error!', error);
          }
        });
    }
  }

  async LoadCountGroupProjectDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectDocumentProjectID'] = Number(this.ProjectId);
      objectjson['ProjectDocumentFileName'] = $('#txtSchFileName').val();
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);


      return this.httpClient
        .post<number>(this.baseurl + "ProjectDocument/GetCountGroupProjectDocument",
          strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadCountHistoryProjectDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectDocumentProjectID'] = Number(this.ProjectId);
      objectjson['ProjectDocumentFileName'] = $('#txtSchFileName').val();
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);


      return this.httpClient
        .post<number>(this.baseurl + "ProjectDocument/GetCountProjectDocument",
          strjson, httpOptions)
        .toPromise();
    }
  }

  GetFileVersion(value: string) {
    var projectDoc = this.ProjectDocumentList.filter((x) => { return x.ProjectDocumentFileName == value });
    if (!!projectDoc && projectDoc.length > 0) {
      $('#txtFileVersion').text(projectDoc[0].ProjectDocumentVersionNo + 1);

    }
  }


  //Events function
  OnUploadTypeChange(selectedValue) {
    switch (selectedValue) {
      case "create":
        $('#FileNameUpdatePanel').addClass('d-none');
        $('#FileNameCreatePanel').removeClass('d-none');
        $('#txtFileVersion').text("-")
        break;
      case "update":
        $('#FileNameUpdatePanel').removeClass('d-none');
        $('#FileNameCreatePanel').addClass('d-none');
        break;
      default:
        $('#FileNameUpdatePanel').addClass('d-none');
        $('#FileNameCreatePanel').removeClass('d-none');
        $('#txtFileVersion').text("-")
        break;
    }
  }

  OnClickConfirmSaveBaselineFile() {
    this.isUploadSubmitted = true;
    
    if (this.Filename == "" || this.Filename == null) {
      alert("Please fill file name.")
      
      this.txtFileNameCreate.markAsTouched({ onlySelf: true });
      this.txtFileNameCreate.markAsDirty({ onlySelf: true });
      this.ValidateFilename = false;

    } else {
      this.ValidateFilename = true;
      this.UploadFilesToServer(this.baselineFilesToUpload);
    }


  }

  OnTextValueChange(value: string) {
    
    this.Filename = value;
    this.ValidateFilename = !!value;
  }

  OnSelectedTabChange(traget) {
    //Collect current tab
    this.CurrentTabSelected = traget.tab.textLabel;

    this._selectLoader(traget.tab.textLabel);
  }


  OnBtnUploadFileClick() {
    $('#ddlFileType').val('create');
    this.OnUploadTypeChange('create');
    this.baselineFilesToUpload = [];
    this.modelFilenameCreate = null;
    this.isUploadSubmitted = false;
    this.ValidateFilename = true;
    this.txtFileName.setValue("");
    $('#txtFileVersion').text('-');

    this.IsClearList = false;
  }

  //Search File Name
  OnBtnSearchClick() {
    this._selectLoader(this.CurrentTabSelected);
  }

  OnBtnClearClick() {
    $('#txtSchFileName').val('');
    this._selectLoader(this.CurrentTabSelected);
  }

  //Upload file
  DragFilesFinished(returnObj) {
    ;
    if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.baselineFilesToUpload = returnObj.Files;
      this.baselinePathFile = returnObj.PathFile;
    }
  }

  UploadFilesToServer(files) {
    
    if (files.length === 0) {
      alert("Please browse file at least one.")
      return;
    }
    let filesToUpload: File[] = files;

    Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.baselinePathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
              // check upload count
              
            }

          } else if (event.type === HttpEventType.Response) {
            
            this.IsClearList = true;
            this.UploadFinished(event.body);

          }
        });


    });

  }

  UploadFinished(traget) {
    $('#modalFileController').modal('hide');
    
    this.InsertProjectDocument(traget.list[0].dbPath);
  }

  async InsertProjectDocument(pathfile) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectDocumentProjectID'] = Number(this.ProjectId);
      objectjson['ProjectDocumentFileName'] = this.Filename;
      objectjson['ProjectDocumentPathFile'] = pathfile;
      objectjson['FlagDelete'] = "N";
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");



      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectInfo[]>(this.baseurl + "ProjectDocument/InsertProjectDocument", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {

          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isSubmitted)

            this.LoadGroupProjectDocument();
          }
        );
    }
  }

  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
    }

    this._selectLoader(this.CurrentTabSelected);
  }

  OnLoadCountDocumentList() {
    //call function load count all ticket list on hand current role user
    if (this.CurrentTabSelected == 'All Document') {
      this.LoadCountGroupProjectDocument().then(data => {
        this.ProjectTotal = data;
        if(this.ProjectTotal == 0) this.currentPageNumber = 0;
        this.totalPages = Math.ceil(this.ProjectTotal / environment.PageSizeSmall);
      });

    }
    else if (this.CurrentTabSelected == 'History') {

      this.LoadCountHistoryProjectDocument().then(data => {
        this.ProjectTotal = data;
        if(this.ProjectTotal == 0) this.currentPageNumber = 0;
        this.totalPages = Math.ceil(this.ProjectTotal / environment.PageSizeSmall);
      });
    }
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    this.GetFileVersion(value);
    this.Filename = value;
    return this.ProjectsFileName.filter(option => option.toLowerCase().includes(filterValue));
  }

  private _selectLoader(tabSelectedKey: string) {
    if (tabSelectedKey == 'All Document') {
      this.IsShowVersion = false;
      this.LoadGroupProjectDocument();
    } else if (tabSelectedKey == 'History') {
      this.IsShowVersion = true;
      this.LoadHistoryProjectDocument();
    }

    this.OnLoadCountDocumentList();
  }

  /******************************* Functions ********************************/
}
